import './Errors.scss';

import { useEffect } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { AppLogo } from '../../components/SVGIcons/AppLogo/AppLogo';
import { CONTACT_SUPPORT_URL } from '../../config/constants';
import { useHideLoader } from '../../hooks/useHideLoader';
import { analytics } from '../../services/analytics';
import { logToNewRelic } from '../../services/debug';
import { useFlag } from '../../services/launchDarkly';
import MaintenancePage from '../Maintenance/Maintenance';

export default function AppError(props: { error: any }) {
  const { error } = props;
  const { t } = useTranslation();

  useHideLoader();

  const isMaintenance = useFlag('maintenance', false);

  useEffect(() => {
    void analytics.sendEvent('error', {
      error_type: error.message,
    });

    console.error('AppError', { context: { error, message: 'AppError', stack: error.stack, test: 'test' } });
    if (window.newrelic) {
      window.newrelic.noticeError(new Error('AppError'), {
        error,
        message: 'AppError',
        stack: error.stack,
        test: 'test',
        context: 'context',
      });
    }

    void logToNewRelic('AppError', { error, errorMessage: error.message, errResponse: error.response }, 'error');
  }, [error]);

  if (isMaintenance) {
    return <MaintenancePage />;
  }

  return (
    <main className="error-page">
      <a href={'/'}>
        <AppLogo alwaysWhite />
      </a>
      <h1>{t('errors.serverError')}</h1>
      <p>{t('errors.oopsMessage')}</p>
      <p>{t('errors.apologyMessage')}</p>
      <p data-testid="app-error-refresh-line">
        <Trans
          components={{
            support: (
              <a
                className="static-site-link support-button"
                href={CONTACT_SUPPORT_URL}
                rel="noreferrer"
                target="_blank"
              />
            ),
          }}
          i18nKey="errors.refreshOrContactSupport"
        />
      </p>
      <p>{t('errors.thankYouMessage')}</p>
    </main>
  );
}
